import {
	Col,
	Form,
	Input,
	message,
	Row,
	Select,
	DatePicker,
	Modal,
	Spin,
	Radio,
} from "antd";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import React, { useEffect, useRef, useState } from "react";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TextArea from "antd/lib/input/TextArea";
import styled from "styled-components";
import { CALL_API } from "common/API";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { getUserInfo, getUserList, getMenuList, getUserRoleId } from "redux/selectors";
import { connect } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
// import Viewmodal from "./Viewmodal";
import { StyledTable } from "atoms/Table";
import axios from "axios";
import { EmployeeInfo } from "../EmployeeInfo";
import user from "../../../assets/employeeinfo.svg";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);
const Wrap = styled.div`
  .score-classification {
	cursor: pointer;
	font-weight: 400;
	font-size: 16px;
	text-align: center;
	text-decoration: underline;
	color: #126df6;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-title {
	font-size: 18px;
	font-weight: bold;
  }
  .item-score {
	font-weight: 400;
	font-size: 14px;
	padding: 10px;
	color: black;
  }
  .item-description {
	font-weight: 400;
	font-size: 14px;
	padding: 10px;
	color: black;
  }
`;

const Attend = ({ userInfo, userList, menuList, userRoleId }) => {
	// PERMISSION FIX: attending (save draft / submit) needs create on Performance -> Mine
	const Menulist = menuList?.[userRoleId] || Object.values(menuList || {})[0];
	const canAttend = !!Menulist?.find(
		(item) => item?.key === "mineappraisal" && item?.permission?.create
	);
	const scrollRef = useRef(null);
	const [form] = Form.useForm();
	const containerRef = useRef(null);
	const { Option } = Select;
	const [loading, setLoading] = useState(false);
	const [loadingnew, setLoadingnew] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const { id } = useParams();
	const roletype = location.state?.roletype;
	const data = location.state?.data;
	const [isScoreModal, setIsScoreModal] = useState(false);
	const [minePerformanceList, setMinePerformanceList] = useState([]);
	const [viewLoading, setViewLoading] = useState(false);
	const [addedJobDescriptions, setAddedJobDescriptions] = useState({});
	const [jobDescriptionInfo, setJobDescriptionInfo] = useState(null);
	const [pdfUrl, setPdfUrl] = useState(null);
	const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
	const [loader, setLoader] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isDraft, setIsDraft] = useState(false);
	const handleCancelModal = () => setIsModalVisible(false);
	const showModal = () => setIsModalVisible(true);

	useEffect(() => {
		if (data?.contractstatus !== "attenddraft") return;

		const succession = data?.successionplanning?.[0] || {};
		const individual = data?.individualassessment?.[0] || {};

		form.setFieldsValue({
			overallsummary: data?.overallsummary || "",
			mentoringrole: succession?.mentoringrole || "none",
			mentoringnextrole: succession?.mentoringnextrole || "none",
			succeedperson: succession?.succeedperson
				? Array.isArray(succession.succeedperson)
					? succession.succeedperson
					: [succession.succeedperson]
				: undefined,
			succeedpersonremark: succession?.succeedpersonremark || "",
			succeedpersonnext: succession?.succeedpersonnext
				? Array.isArray(succession.succeedpersonnext)
					? succession.succeedpersonnext
					: [succession.succeedpersonnext]
				: undefined,
			succeedpersonremarknext: succession?.succeedpersonremarknext || "",
			...individual,
			cvlastupdateddate: individual?.cvlastupdateddate
				? dayjs(individual.cvlastupdateddate)
				: null,
		});
	}, [data?.contractstatus]);

	const selectedEmployee = userList?.find(
		(item) => item?.userid === data?.apraiseemailid
	);

	const scoreData = [
		{ score: "6", description: "Exceptional performance", color: "#03C83E" },
		{
			score: "5",
			description: "Exceeds minimum requirements",
			color: "#7DCA4ACC",
		},
		{
			score: "4",
			description: "Meets all minimum requirements",
			color: "#FFFF68",
		},
		{
			score: "3",
			description: "Typically meets minimum requirements",
			color: "#ED7D31CC",
		},
		{
			score: "2",
			description: "Does not meet minimum requirements",
			color: "#FF0000CC",
		},
		{ score: "1", description: "Unacceptable performance", color: "#C00000CC" },
	];
	const findUser = userList?.find((item) => item?.userid === userInfo?.userid);

	const options = [
		{ label: "None", value: "none" },
		{ label: "Choose People", value: "choose" },
	];

	const userAppraisalInfo = userList
		.find((item) => item?.userid === userInfo?.userid)
		?.appraisalInformation?.filter((val) => val?.roletype === data?.roletype);
	const jobdescriptionid = userAppraisalInfo?.[0]?.jobDescriptionId;
	const jobdescriptionFileName = userAppraisalInfo?.[0]?.jobdescriptionFileName;

	const viewJobDescription = async () => {
		if (!jobdescriptionid || !jobdescriptionFileName) {
			message.warning("User has not created a Job Description.");
			return;
		}
		const token = window.localStorage.getItem("token") || "";
		try {
			setLoader(true);
			const response = await axios.get(
				"https://h8gw6wo6o3.execute-api.us-west-1.amazonaws.com/Prod/appraisal/getdocument",
				{
					params: {
						jobdescriptionid: jobdescriptionid,
						filename: jobdescriptionFileName,
					},
					headers: { Tymeplusjwt: token },
				}
			);
			if (response?.data?.status === "SUCCESS" && response?.data?.url) {
				setPdfUrl(response.data.url);
				setIsPdfModalOpen(true);
			} else {
				message.error(response?.data?.message || "Failed to fetch document.");
				setLoader(false);
			}
		} catch (error) {
			message.error(error?.message || "Failed to fetch document.");
			setLoader(false);
		} finally {
			setLoader(false);
		}
	};

	const handleViewJobDescription = (userList) => {
		if (!Array.isArray(userList)) {
			message.error("Invalid user data.");
			return;
		}
		viewJobDescription();
	};

	const [validationErrors, setValidationErrors] = useState({});

	const [validationDataErrors, setValidationDataErrors] = useState({});

	const TechnicalDataMaster = [
		{
			id: 1,
			objectives: "Strategic / Target Objectives",
		},
		data?.rolloverresponsibility?.length > 0 && {
			id: 2,
			objectives: "Actions expected from previous Appraisal",
		},
		{
			id: 3,
			objectives: "Key responsibilities (from job descriptions)",
		},
		{
			id: 4,
			objectives: "Additional Roles/ Backstopping Roles",
		},
		data?.rolloverresponsibility?.length > 0 && {
			id: 5,
			objectives: "Actions expected from previous Appraisal",
		},
	];

	let TechnicalData = [];
	if (roletype === "Primary") {
		TechnicalData = TechnicalDataMaster.filter((item) =>
			[1, 2, 3].includes(item.id)
		);
	} else if (
		roletype === "Additional 1" ||
		roletype === "Additional 2" ||
		roletype === "Additional 3"
	) {
		TechnicalData = TechnicalDataMaster.filter((item) =>
			[1, 4, 5].includes(item.id)
		);
	} else {
		TechnicalData = TechnicalDataMaster;
	}

	const [technicalAssessmentData, setTechnicalAssessmentData] = useState(() => {
		if (data?.contractstatus === "attenddraft" && data?.technicalassessment?.length > 0) {
			return TechnicalData.map((row) => {
				const saved = data.technicalassessment.find((t) => t.id === row.id);
				// spread row first (base structure), then saved on top (fills in saved values)
				// saved may be partial — only overwrite fields that exist and are non-null
				return saved
					? {
						...row,
						...(saved.whatwentwellmajorachivement !== undefined && {
							whatwentwellmajorachivement: saved.whatwentwellmajorachivement,
						}),
						...(saved.whatdidnotgowellchallenges !== undefined && {
							whatdidnotgowellchallenges: saved.whatdidnotgowellchallenges,
						}),
						...(saved.selfscore !== undefined && {
							selfscore: saved.selfscore,
						}),
					}
					: row;
			});
		}
		return TechnicalData;
	});

	const handleDataChange = (value, record, field) => {
		setSoftSkillData((prev) =>
			prev.map((item) =>
				item.id === record.id ? { ...item, [field]: value } : item
			)
		);

		// Clear validation error for this field
		setValidationDataErrors((prevErrors) => {
			if (!prevErrors?.[record.id]?.[field]) return prevErrors;
			const updated = { ...prevErrors };
			updated[record.id] = { ...updated[record.id] };
			delete updated[record.id][field];
			if (Object.keys(updated[record.id]).length === 0) {
				delete updated[record.id];
			}
			return updated;
		});
	};

	const handleChange = (value, record, field) => {
		const updatedData = technicalAssessmentData.map((item) => {
			if (item.id === record.id) {
				return { ...item, [field]: value };
			}
			return item;
		});

		setTechnicalAssessmentData(updatedData);

		if (validationErrors?.[record.id]?.[field]) {
			const updatedErrors = { ...validationErrors };
			delete updatedErrors[record.id][field];
			if (Object.keys(updatedErrors[record.id]).length === 0) {
				delete updatedErrors[record.id];
			}
			setValidationErrors(updatedErrors);
		}
	};

	const technicalAssessmentColumns = [
		{
			title: "Objectives",
			dataIndex: "objectives",
			key: "objectives",
			render: (text, record) => {
				return (
					<span
						style={{ color: "#0066FF", cursor: "pointer" }}
						onClick={async () => {
							setModalLoading(true);
							setLoadingnew(true);

							try {
								// use record.roletype, not data.roletype
								const roletype = data.roletype;

								const res = await CALL_API(
									`appraisal/appraiseemine?userid=${userInfo.userid}`,
									"get"
								);
								if (res?.code === "SUCCESS") {
									// get the full array
									const contractList = Array.isArray(
										res.performanceContractList
									)
										? res.performanceContractList
										: [];

									// find by record.roletype
									const contract = contractList.find(
										(item) => item?.contractid === data?.contractid
									);

									if (contract) {
										setObjectiveModal({
											open: true,
											objective: text,
											contract,
										});
									} else {
										message.error(
											`No contract found for this role. roletype searched: "${data.roletype}"`
										);
									}
								} else {
									message.error("Failed to fetch contract data.");
								}
							} catch (error) {
								message.error("Failed to fetch contract data.");
							} finally {
								setModalLoading(false);
								setLoadingnew(false);
							}
						}}
					>
						{text}
					</span>
				);
			},
		},

		{
			title: "What went well / Major achievements",
			dataIndex: "whatwentwellmajorachivement",
			key: "whatwentwellmajorachivement",
			width: "30%",
			render: (text, record) => (
				<Input.TextArea
					autoSize={{ minRows: 1, maxRows: 6 }}
					placeholder="Enter achievement..."
					value={record.whatwentwellmajorachivement}
					onChange={(e) =>
						handleChange(e.target.value, record, "whatwentwellmajorachivement")
					}
					style={{
						width: "100%",
						border: validationErrors?.[record.id]?.whatwentwellmajorachivement
							? "1px solid red"
							: undefined,
					}}
				/>
			),
		},
		{
			title: "What can be improved / Challenges",
			dataIndex: "whatdidnotgowellchallenges",
			key: "whatdidnotgowellchallenges",
			width: "30%",
			render: (text, record) => (
				<Input.TextArea
					autoSize={{ minRows: 1, maxRows: 6 }}
					placeholder="Enter challenges..."
					value={record.whatdidnotgowellchallenges}
					onChange={(e) =>
						handleChange(e.target.value, record, "whatdidnotgowellchallenges")
					}
					style={{
						width: "100%",
						border: validationErrors?.[record.id]?.whatdidnotgowellchallenges
							? "1px solid red"
							: undefined,
					}}
				/>
			),
		},
		{
			title: "Self Score",
			dataIndex: "selfscore",
			key: "selfscore",
			render: (text, record) => (
				<Select
					placeholder="Select score"
					value={record.selfscore}
					onChange={(value) => handleChange(value, record, "selfscore")}
					style={{
						width: "100%",
						border: validationErrors?.[record.id]?.selfscore
							? "1px solid red"
							: undefined,
					}}
				>
					{[1, 2, 3, 4, 5, 6].map((score) => (
						<Select.Option key={score} value={score}>
							{score}
						</Select.Option>
					))}
				</Select>
			),
		},
	];

	const handleDataValidation = () => {
		const errors = {};
		let isValid = true;

		softSkillData.forEach((record) => {
			const {
				id,
				whatwentwellmajorachivement,
				whatdidnotgowellchallenges,
				selfscore,
			} = record;

			if (!errors[id]) errors[id] = {};

			if (!whatwentwellmajorachivement && roletype === "Primary") {
				errors[id].whatwentwellmajorachivement = true;
				isValid = false;
			}

			if (!whatdidnotgowellchallenges && roletype === "Primary") {
				errors[id].whatdidnotgowellchallenges = true;
				isValid = false;
			}

			if (!selfscore && roletype === "Primary") {
				errors[id].selfscore = true;
				isValid = false;
			}
		});

		setValidationDataErrors(errors);

		if (!isValid) {
			message.error("Please fill in all required soft skill fields.");
		}

		return isValid;
	};

	const handleValidation = () => {
		const errors = {};
		let isValid = true;

		technicalAssessmentData.forEach((record) => {
			const {
				id,
				whatwentwellmajorachivement,
				whatdidnotgowellchallenges,
				selfscore,
			} = record;

			if (!errors[id]) errors[id] = {};

			if (!whatwentwellmajorachivement) {
				errors[id].whatwentwellmajorachivement = true;
				isValid = false;
			}

			if (!whatdidnotgowellchallenges) {
				errors[id].whatdidnotgowellchallenges = true;
				isValid = false;
			}

			if (!selfscore) {
				errors[id].selfscore = true;
				isValid = false;
			}
		});

		setValidationErrors(errors);

		if (!isValid) {
			message.error("Please fill in all required fields.");
		}

		return isValid;
	};

	const dataColumns = [
		{
			title: "Objectives",
			dataIndex: "objective",
			key: "objective",
		},
		{
			title: "Weightage (%)",
			dataIndex: "weightage",
			key: "weightage",
		},
		{
			title: "What went well/ Major achievement",
			dataIndex: "whatwentwellmajorachivement",
			width: "30%",
			render: (text, record) => (
				<Input.TextArea
					autoSize={{ minRows: 1, maxRows: 6 }}
					placeholder="Enter..."
					value={record.whatwentwellmajorachivement}
					onChange={(event) =>
						handleDataChange(
							event.target.value,
							record,
							"whatwentwellmajorachivement"
						)
					}
					style={{
						width: "100%",
						border: validationDataErrors?.[record.id]
							?.whatwentwellmajorachivement
							? "1px solid red"
							: "",
					}}
				/>
			),
		},
		{
			title: "What can be improved/ Challenges",
			dataIndex: "whatdidnotgowellchallenges",
			width: "30%",
			render: (text, record) => (
				<Input.TextArea
					autoSize={{ minRows: 1, maxRows: 6 }}
					placeholder="Enter..."
					value={record.whatdidnotgowellchallenges}
					onChange={(event) =>
						handleDataChange(
							event.target.value,
							record,
							"whatdidnotgowellchallenges"
						)
					}
					style={{
						width: "100%",
						border: validationDataErrors?.[record.id]
							?.whatdidnotgowellchallenges
							? "1px solid red"
							: "",
					}}
				/>
			),
		},
		{
			title: "Self score",
			dataIndex: "selfscore",
			render: (text, record) => (
				<Select
					placeholder="Select..."
					value={record.selfscore}
					onChange={(value) => handleDataChange(value, record, "selfscore")}
					style={{
						border: validationDataErrors?.[record.id]?.selfscore
							? "1px solid red"
							: "",
					}}
				>
					{[1, 2, 3, 4, 5, 6]?.map((num) => (
						<Select.Option key={num} value={num}>
							{num}
						</Select.Option>
					))}
				</Select>
			),
		},
	];

	const [softSkillData, setSoftSkillData] = useState(() => {
		if (data?.contractstatus === "attenddraft" && data?.softskills?.length > 0) {
			// ✅ Just map directly by index — no find needed, array order is stable
			return data.softskills.map((item, index) => ({
				...item,
				id: item.id ?? index + 1,  // use existing id if present
			}));
		}
		// Fresh form — softskills come from the contract, assign stable ids by index
		return (data?.softskills || []).map((item, index) => ({
			...item,
			id: index + 1,
		}));
	});

	const footerStyle = {
		position: "sticky",
		bottom: 0,
		left: 0,
		right: 0,
		backgroundColor: "#fff",
		padding: "10px",
		display: "flex",
		justifyContent: "end",
		boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
		margin: "0px -20px",
	};

	const create = () => {
		history.push({
			pathname: "/performancemanagement",
			state: {
				tabId: "mineappraisal",
				selectedItem: "performance-management",
			},
		});
	};

	const handleFormSubmit = async (values) => {
		if (!canAttend) return;
		// Skip validation for draft
		const isValid = isDraft
			? true
			: handleValidation() && handleDataValidation();

		if (isValid) {
			setLoading(true);
			const payload = {
				appraiseeroletype: roletype,
				performanceid: data?.performanceid,
				individualassessment: [
					{
						...values,
						cvlastupdateddate: values.cvlastupdateddate
							? values.cvlastupdateddate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
							: "",
					},
				],
				clusterlevel: [
					{
						revenue: Number(values.revenuerevvsbudgetandgoly),
						departmentprofit: Number(values.departmentalprofitvsbudgetgoly),
						employeeprofit: Number(values.revprofitperemployee),
						employeecost: Number(values.employeecostprofitsasageofrev),
						debtors: Number(values.debotorsinusdanddays),
					},
				],
				technicalassessment: technicalAssessmentData,
				softskills: softSkillData,
				employeescorecard: {},
				overallsummary: values.overallsummary,
				rolledovernextappraisal: [],
				appraiseescareergrowth: [],
				successionplanning: [
					{
						mentoringrole: values.mentoringrole || "",
						mentoringnextrole: values.mentoringnextrole || "",
						succeedpersonremark: values.succeedpersonremark || "",
						succeedperson: values.succeedperson || "",
						succeedpersonremarknext: values.succeedpersonremarknext || "",
						succeedpersonnext: values.succeedpersonnext || "",
					},
				],
				overallrating: [],
				appraiseeemailid: findUser?.userid || "",
				contractid: Number(id),
				employeeid: findUser?.employeeid || "",
				employeename: findUser?.fullname || "",
				appraisarmailid: data?.appraisarmailid || "",
				reviewedon: "",
				averagetechnicalscore: 0,
				averagesoftscore: 0,
				reviewedby: "",
				appraiserreview: [],
				contractstatus: isDraft ? "attenddraft" : "attended",  // 👈 key change
				attendedon: new Date().toISOString(),
				attendedby: userInfo?.userid,
			};
			const { code, response } = await CALL_API(
				"appraisal/attend",
				"post",
				payload
			);
			if (code === STATUS_CODE?.SUCCESS) {
				setLoading(false);
				message.success(isDraft ? "Draft saved successfully" : "Appraisal submitted successfully");
				history.push("/performancemanagement", {
					state: {
						response,
						draftContractId: isDraft ? Number(id) : null,  // 👈 pass contractid back
						tabId: "mineappraisal",
						selectedItem: "performance-management",
					}
				});
			}

			setLoading(false);
			setIsDraft(false); // reset after submission
		}
	};

	const showSoftSkillData = roletype === "Primary";

	// Add this state at the top inside Attend component
	const [objectiveModal, setObjectiveModal] = useState({
		open: false,
		objective: null,
		contract: null,
	});
	const [modalLoading, setModalLoading] = useState(false);

	// Helper for modal config
	const getObjectiveModalConfig = (objective) => {
		switch (objective) {
			case "Strategic / Target Objectives":
				return {
					title: "Strategic objectives",
					secondCol:
						"Strategic objectives aligned to Organizational Strategy for the upcoming appraisal period",
				};
			case "Actions expected from previous Appraisal":
				return {
					title: "Rollover Responsibility from Previous Appraisal",
					secondCol:
						"Objectives that Rolled Over from Previous Appraisal Period",
				};
			case "Key responsibilities (from job descriptions)":
				return {
					title: "Objectives from JD for the Current Appraisal Period",
					secondCol:
						"Target objectives aligned to Organizational Strategy for the current appraisal period",
				};
			case "Additional Roles/ Backstopping Roles":
				return {
					title: "Objectives from JD for the Current Appraisal Period",
					secondCol:
						"Target objectives aligned to Organizational Strategy for the Current appraisal period",
				};
			default:
				return {
					title: "",
					secondCol: "",
				};
		}
	};

	// Helper for mapping API data to modal table
	const getObjectiveDataFromContract = (objective, contract) => {
		switch (objective) {
			case "Strategic / Target Objectives":
				return (contract?.startegicobjectives || []).map((item, idx) => ({
					sno: idx + 1,
					main: item.straobjorgstartegy,
					expectedoutcome: item.expectedoutcome,
					targetdate: dayjs(item.TargetDate, "YYYY-MM-DD")?.format(
						"DD-MM-YYYY"
					),
					weightage: item.Weightage,
				}));
			case "Actions expected from previous Appraisal":
				return (contract?.rolloverresponsibility || []).map((item, idx) => ({
					sno: idx + 1,
					main: item.previousappraisalperiod,
					expectedoutcome: item.expectedoutcome,
					targetdate: dayjs(item.TargetDate, "YYYY-MM-DD")?.format(
						"DD-MM-YYYY"
					),
					weightage: item.Weightage,
				}));
			case "Additional Roles/ Backstopping Roles":
				return (contract?.upcomingappraisalperiod || []).map((item, idx) => ({
					sno: idx + 1,
					main: item.upcomingappraisalperiod,
					expectedoutcome: item.expectedoutcome,
					targetdate: dayjs(item.TargetDate, "YYYY-MM-DD")?.format(
						"DD-MM-YYYY"
					),
					weightage: item.Weightage,
				}));
			case "Key responsibilities (from job descriptions)":
				return (contract?.upcomingappraisalperiod || []).map((item, idx) => ({
					sno: idx + 1,
					main: item.upcomingappraisalperiod,
					expectedoutcome: item.expectedoutcome,
					targetdate: dayjs(item.TargetDate, "YYYY-MM-DD")?.format(
						"DD-MM-YYYY"
					),
					weightage: item.Weightage,
				}));
			default:
				return [];
		}
	};

	// Find the contract for the current roletype
	const currentContract = minePerformanceList.find(
		(item) => item.roletype?.toLowerCase() === roletype?.toLowerCase()
	);

	// Get the data for the modal table
	const modalTableData = getObjectiveDataFromContract(
		objectiveModal.objective,
		objectiveModal.contract
	);

	return (
		<>
			<Modal
				open={isPdfModalOpen}
				onCancel={() => setIsPdfModalOpen(false)}
				footer={null}
				width={1000}
				centered
				bodyStyle={{ height: "80vh", padding: 0 }}
			>
				{pdfUrl ? (
					<iframe
						src={pdfUrl}
						title="PDF Preview"
						width="100%"
						height="100%"
						style={{ border: "none" }}
					/>
				) : (
					<p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
				)}
			</Modal>
			{loadingnew && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						backgroundColor: "rgba(255, 255, 255, 0.7)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						zIndex: 9999,
					}}
				>
					<Spin size="large" />
				</div>
			)}

			<div ref={scrollRef} className="scrollable-container">
				<label
					className="bg-transparent border-0 mb-3 text-left styled-cursor"
					// onClick={() => closeModal(false)}
					onClick={create}
				>
					Performance Management <ArrowForwardIosIcon className="px-1" />
				</label>
				{"Attending Appraisal"}
				<h4>Appraisal Form</h4>
				<br />
				<h6>
					Employee Scorecard - Power BI -{" "}
					<a
						href="https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience=power-bi"
						id="m_-8402443038962109074m_-6895529901520386798OWAb5b7a0de-4f34-011d-612c-0f428cd224db"
						target="_blank"
						data-saferedirecturl="https://www.google.com/url?q=https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience%3Dpower-bi&amp;source=gmail&amp;ust=1751024712172000&amp;usg=AOvVaw3TFhX25zyjt-Ip9o8oqWYh"
					>
						Employee Scorecard - Power BI
					</a>
				</h6>
				<br></br>

				<>
					<Form
						form={form}
						layout="vertical"
						onFinish={(values) => handleFormSubmit(values)}
						initialValues={{ mentoringrole: "none", mentoringnextrole: "none" }}
					>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div>
								<b>Technical Assessment</b>
							</div>
							<Wrap>
								<div>
									<p
										className="score-classification"
										type="link"
										onClick={() => setIsScoreModal(true)}
									>
										Score Classification
									</p>
								</div>
							</Wrap>
						</div>
						<Row>
							{/* <Wrap> */}
							<StyledTable
								className="w-100 mb-2"
								dataSource={technicalAssessmentData}
								columns={technicalAssessmentColumns}
								pagination={false}
								rowKey="id"
							/>
							{/* </Wrap> */}
						</Row>
						<StyledModal
							title="Score Classification"
							open={isScoreModal}
							footer={null}
							onCancel={() => setIsScoreModal(false)}
						>
							<table
								style={{
									width: "100%",
									borderCollapse: "collapse",
									borderRadius: "8px",
								}}
							>
								<tbody>
									{scoreData?.map((item, index) => (
										<tr
											key={index}
											style={{ backgroundColor: item.color, color: "#fff" }}
										>
											<td className="item-score">{item.score}</td>
											<td className="item-description">{item.description}</td>
										</tr>
									))}
								</tbody>
							</table>
						</StyledModal>
						<br />
						{roletype === "Primary" && (
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<div>
									<b>Individual ( Soft skils ) Assessment / BDO VALUES</b>
								</div>
								<Wrap>
									<div>
										<p
											className="score-classification"
											type="link"
											onClick={() => setIsScoreModal(true)}
										>
											Score Classification
										</p>
									</div>
								</Wrap>
							</div>
						)}
						{roletype === "Primary" && (
							<>
								<Row>
									{/* <Wrap> */}
									<StyledTable
										className="w-100 mb-3"
										dataSource={softSkillData}
										columns={dataColumns}
										pagination={false}
										rowKey="id"
									/>
									{/* </Wrap> */}
								</Row>
							</>
						)}

						{roletype === "Primary" && (
							<>
								<div style={{ marginTop: "20px", marginBottom: "10px" }}>
									<Row>
										<b>Succession Planning</b>
									</Row>
								</div>
								<Row
									style={{
										background: "#fafafa",
										padding: "15px",
										marginBottom: "15px",
										borderRadius: "8px",
									}}
									gutter={16}
								>
									<Col xs={24} md={12}>
										Who am I mentoring for my role?
									</Col>
									<Col xs={24} md={12}>
										<Form.Item name="mentoringrole">
											<Radio.Group options={options} optionType="default" />
										</Form.Item>
										{form.getFieldValue("mentoringrole") === "choose" && (
											<>
												<Form.Item
													name="succeedperson"
													label="Choose People"
													rules={[
														{
															required:
																roletype === "Primary" &&
																	form.getFieldValue("mentoringrole") === "choose"
																	? true
																	: false,
															message: "Choose people is required",
														},
													]}
												>
													<Select
														className=""
														mode="multiple"
														placeholder="Select multiple items"
														options={userList?.map((appraiser) => ({
															value: appraiser?.userid,
															label: appraiser?.fullname,
														}))}
													/>
												</Form.Item>
												<Form.Item
													name="succeedpersonremark"
													label="Remark"
													rules={[
														{
															required:
																roletype === "Primary" &&
																	form.getFieldValue("mentoringrole") === "choose"
																	? true
																	: false,
															message: "Remark is required",
														},
													]}
												>
													<TextArea
														placeholder="Remark"
														allowClear
														className="textarea_dropdown_container"
													/>
												</Form.Item>
											</>
										)}
									</Col>
									<Col xs={24} md={12}>
										Who is mentoring me for my next role?
									</Col>

									<Col xs={24} md={12}>
										<Form.Item name="mentoringnextrole">
											<Radio.Group options={options} optionType="default" />
										</Form.Item>
										{form.getFieldValue("mentoringnextrole") === "choose" && (
											<>
												<Form.Item
													name="succeedpersonnext"
													label="Choose People"
													rules={[
														{
															required:
																roletype === "Primary" &&
																	form.getFieldValue("mentoringnextrole") ===
																	"choose"
																	? true
																	: false,
															message: "Choose people is required",
														},
													]}
												>
													<Select
														className=""
														mode="multiple"
														placeholder="Select multiple items"
														options={userList?.map((appraiser) => ({
															value: appraiser?.userid,
															label: appraiser?.fullname,
														}))}
													/>
												</Form.Item>
												<Form.Item
													name="succeedpersonremarknext"
													label="Remark"
													rules={[
														{
															required:
																roletype === "Primary" &&
																	form.getFieldValue("mentoringnextrole") ===
																	"choose"
																	? true
																	: false,
															message: "Remark is required",
														},
													]}
												>
													<TextArea
														placeholder="Remark"
														allowClear
														className="textarea_dropdown_container"
													/>
												</Form.Item>
											</>
										)}
									</Col>
								</Row>
							</>
						)}

						<b>
							<span style={{ color: "red" }}>*</span> Overall Summary
						</b>

						<Row className="mt-3">
							<Col xs={24} sm={24} md={24}>
								<Form.Item
									name="overallsummary"
									label=""
									rules={[
										{
											required: !isDraft,
											pattern: NON_EMPTY_REGEX,
											message: "Overall Summary is required",
										},
									]}
								>
									<TextArea placeholder="Overall Summary" />
								</Form.Item>
							</Col>
						</Row>
						<br />
						<br />
						<div style={footerStyle}>
							<ButtonOutlined onClick={create}>Cancel</ButtonOutlined>

							{canAttend && (
								<>
									<ButtonFilled
										loading={loading && isDraft}
										onClick={() => {
											setIsDraft(true);
											setTimeout(() => form.submit(), 0);  // triggers onFinish after state updates
										}}
									>
										Save as Draft
									</ButtonFilled>

									<ButtonFilled
										loading={loading && !isDraft}
										type="primary"
										onClick={() => {
											setIsDraft(false);
											setTimeout(() => form.submit(), 0);
										}}
									>
										Submit
									</ButtonFilled>
								</>
							)}
						</div>
					</Form>
				</>

				<StyledModal
					title={
						<div style={{ display: "flex", alignItems: "center" }}>
							<span style={{ flex: 1 }}>
								{getObjectiveModalConfig(objectiveModal.objective).title}
							</span>
							<span style={{ marginRight: 24 }}>
								<a
									onClick={() => {
										handleViewJobDescription(userList);
									}}
									style={{
										cursor: "pointer",
										fontSize: "16px",
										color: "#1890ff",
										fontWeight: "500",
										textDecoration: "underline",
									}}
								>
									{viewLoading || loader ? (
										<LoadingOutlined />
									) : (
										"Job Description"
									)}
								</a>
							</span>
						</div>
					}
					open={objectiveModal.open}
					footer={null}
					onCancel={() =>
						setObjectiveModal({ open: false, objective: null, contract: null })
					}
					width={1000}
					borderRadius="8px"
				>
					<Spin spinning={modalLoading} size="large">
						{!modalLoading && (
							<table style={{ width: "100%", borderCollapse: "collapse" }}>
								<thead>
									<tr>
										<th style={{ border: "1px solid #eee", padding: 8 }}>
											S.No
										</th>
										<th style={{ border: "1px solid #eee", padding: 8 }}>
											{
												getObjectiveModalConfig(objectiveModal.objective)
													.secondCol
											}
										</th>
										<th style={{ border: "1px solid #eee", padding: 8 }}>
											Expected Outcome
										</th>
										<th
											style={{
												width: "15%",
												border: "1px solid #eee",
												padding: 8,
											}}
										>
											Target Date
										</th>
										<th style={{ border: "1px solid #eee", padding: 8 }}>
											Weightage
										</th>
									</tr>
								</thead>
								<tbody>
									{modalTableData.length > 0 ? (
										modalTableData.map((row, idx) => (
											<tr key={idx}>
												<td style={{ border: "1px solid #eee", padding: 8 }}>
													{row.sno}
												</td>
												<td style={{ border: "1px solid #eee", padding: 8 }}>
													{row.main}
												</td>
												<td style={{ border: "1px solid #eee", padding: 8 }}>
													{row.expectedoutcome}
												</td>
												<td
													style={{
														width: "15%",
														border: "1px solid #eee",
														padding: 8,
													}}
												>
													{dayjs(row.targetdate, "DD-MM-YYYY").format(
														"Do MMM YYYY"
													)}
												</td>
												<td style={{ border: "1px solid #eee", padding: 8 }}>
													{row.weightage}
												</td>
											</tr>
										))
									) : (
										<tr>
											<td
												colSpan={5}
												style={{ textAlign: "center", padding: 8 }}
											>
												No data available
											</td>
										</tr>
									)}
								</tbody>
							</table>
						)}
					</Spin>
				</StyledModal>
			</div>
			<img
				src={user}
				alt="Floating User Icon"
				style={{
					position: "fixed",
					bottom: "50px",
					right: "50px",
					width: "100px",
					height: "100px",
					borderRadius: "50%",
					zIndex: 1000,
					cursor: "pointer",
				}}
				onClick={showModal}
			/>
			<EmployeeInfo
				isModalVisible={isModalVisible}
				handleCancelModal={handleCancelModal}
				selectedEmployee={selectedEmployee}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	userInfo: getUserInfo(state),
	userList: getUserList(state),
	menuList: getMenuList(state),
	userRoleId: getUserRoleId(state),
});

export default connect(mapStateToProps)(Attend);
